import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  closeActivityListModel,
  openActivityCategoryModel,
  openActivityDetailModel,
} from "../../store/slices/modalSlice";
import { useEffect, useMemo, useRef, useState } from "react";
import { Activity, getDataForDedActivityListPageApi } from "../../lib/api";
import {
  setActivityCategory,
  setActivityCode,
} from "../../store/slices/IdSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import DetPagination from "../../pages/dedActivities/DetPagination";

const PAGE_SIZE = 5;

const ActivityList = () => {
  const dispatch = useDispatch();
  const activityListModel = useSelector(
    (state: { modal: { activityListModel: boolean } }) =>
      state.modal.activityListModel
  );
  const dedGroupName = useSelector((state: any) => state.ID.dedGroupName);
  const dedCategoryslug = useSelector((state: any) => state.ID.dedCategoryslug);
  const [activities, setActivities] = useState<Activity | null>(null);
  const [page, setPage] = useState(1);
  const [totalActivities, setTotalActivities] = useState<number | 0>(0);
  const [query, setQuery] = useState("");

  const modalBodyRef = useRef<HTMLDivElement | null>(null);

  const fetchActivities = async () => {
    if (!activityListModel) return;
    try {
      if (dedGroupName !== "") {
        dispatch(setActivityCategory({ catId: 0, slug: "" }));
      }
      const data: Activity = await getDataForDedActivityListPageApi(
        dedCategoryslug,
        dedGroupName
      );
      setActivities(data);
      setTotalActivities(data.subActivities.length || 0);
    } catch (err) {
      console.error("Failed to fetch activities:", err);
    } finally {
    }
  };

  useEffect(() => {
    if (!activityListModel) return;
    import("./DedActivityCss.css"); // lazy load CSS
    fetchActivities();
  }, [activityListModel]);

  const filtered = useMemo(() => {
    if (!activities) return [];
    const q = query.trim().toLowerCase();
    if (!q) return activities.subActivities;
    return activities.subActivities.filter(
      (r) =>
        r.activityCode.toLowerCase().includes(q) ||
        r.name.toLowerCase().includes(q) ||
        r.groupName.toLowerCase().includes(q) ||
        r.licenseType.toLowerCase().includes(q)
    );
  }, [query, activities, page]);

  const pages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const safePage = Math.min(page, pages);
  const start = (safePage - 1) * PAGE_SIZE;
  const pageRows = filtered.slice(start, start + PAGE_SIZE);

  const handleCloseModal = () => dispatch(closeActivityListModel());
  const handleBackModal = () => {
    dispatch(closeActivityListModel());
    dispatch(openActivityCategoryModel());
  };

  const handleGetActivityDetail = (activityCode: string) => {
    dispatch(setActivityCode(activityCode));
    dispatch(closeActivityListModel());
    dispatch(openActivityDetailModel());
  };

  return (
    <Modal
      show={activityListModel}
      onHide={handleCloseModal}
      scrollable
      centered
      backdrop="static"
      className="mb-fix slide-from-bottom activity-modal "
    >
      {/* <Modal.Header closeButton></Modal.Header> */}
      <Modal.Body ref={modalBodyRef} className="modal-dialog-scrollable pt-0">
        <div className="back-position border-bottom-1pt  py-3 ">
          <div className="btn-back-item" onClick={() => handleBackModal()}>
            <a href="javascript:void(0);">
              {" "}
              <FontAwesomeIcon icon={faChevronLeft} />{" "}
              <span className="d-sm-none d-md-block">Back</span>
            </a>
          </div>
          <h3 className="modal-title text-uppercase text-center font-20 ff-semibold m-0 w-100">
            Sub Activity
          </h3>
        </div>
        <div className="search-section-act bg-gray-act mb-3">
          <div className="secrch-box-act">
            <input
              className="form-control font-12"
              type="text"
              placeholder="Search activity"
              value={query}
              onChange={(e) => {
                setQuery(e.target.value);
                setPage(1);
              }}
            />
            <span className="search-icon-act">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <path d="M21 21L16.65 16.65"></path>
              </svg>
            </span>
          </div>
        </div>
        <div className="row align-items-center justify-content-between mt-3 mb-3">
          <div className="col-auto">
            <h3 className="modal-title text-left font-16 ff-semibold m-0 text-wid-fix">
              {activities?.name}
            </h3>
          </div>
          <div className="col-auto">
            <h3 className="modal--right-text text-end font-12 ff-semibold">
              You have {totalActivities} results
            </h3>
          </div>
        </div>
        <div className="ded-activity-table-wrap">
          <div className="table-responsive mb-0">
            <table className="table mb-0 ded-activity-table">
              <thead>
                <tr>
                  <th style={{ width: "140px" }}>Activity Code</th>
                  <th style={{ width: "200px" }}>Activity</th>
                  <th style={{ width: "140px" }}>Activity Group</th>
                  <th style={{ width: "180px" }} className="text-end">
                    Licence Type
                  </th>
                </tr>
              </thead>
              <tbody>
                {pageRows.map((item) => (
                  <tr
                    key={`detail-${item.categoryID}-${item.activityCode}`}
                    className="ded-activity-row"
                  >
                    <td
                      className="ded-activity-code"
                      onClick={() => handleGetActivityDetail(item.activityCode)}
                    >
                      <a
                        href="javascript:void(0);"
                        aria-label={`Open ${item.activityCode}`}
                      >
                        {item.activityCode}
                      </a>
                    </td>
                    <td>{item.name}</td>
                    <td>{item.groupName}</td>
                    <td className="text-end">
                      <span className="ded-activity-licence-pill">
                        {item.licenseType}
                      </span>
                    </td>
                  </tr>
                ))}
                {pageRows.length === 0 && (
                  <tr>
                    <td colSpan={4} className="text-center py-4 text-muted">
                      No results.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <DetPagination page={safePage} pages={pages} onChange={setPage} />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ActivityList;
